/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_ScreenInputs */

const en_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Screen`)
};

const es_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalla completa`)
};

const fr_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plein écran`)
};

const de_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbild`)
};

const ja_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面表示`)
};

const zh_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏`)
};

const ar_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملء الشاشة`)
};

const id_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layar Penuh`)
};

const it_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schermo Intero`)
};

const ru_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На весь экран`)
};

const pt_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tela Cheia`)
};

const ko_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체 화면`)
};

/**
* | output |
* | --- |
* | "Full Screen" |
*
* @param {Full_ScreenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const full_screen = /** @type {((inputs?: Full_ScreenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_ScreenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_screen(inputs)
	if (locale === "es") return es_full_screen(inputs)
	if (locale === "fr") return fr_full_screen(inputs)
	if (locale === "de") return de_full_screen(inputs)
	if (locale === "ja") return ja_full_screen(inputs)
	if (locale === "zh") return zh_full_screen(inputs)
	if (locale === "ar") return ar_full_screen(inputs)
	if (locale === "id") return id_full_screen(inputs)
	if (locale === "it") return it_full_screen(inputs)
	if (locale === "ru") return ru_full_screen(inputs)
	if (locale === "pt") return pt_full_screen(inputs)
	return ko_full_screen(inputs)
});